<template>
  <div>
    <div>
        <label>Type Of Issue</label>
            <SelectWithSearch
                    :key="final.selectedIssue?.key"
                    :full_object="true"
                    :optionsData="issues"            
                    :search_without_api="true"
                    track_by="key"
                    display="value"
                    :selected_data="final.selectedIssue?.key"
                    selected_by="key"
                    @selectedOption="selectedIssue($event)"
                ></SelectWithSearch>
    </div>
    
    <b-tabs v-model="activeTab" style="margin-top: 20px">
      <b-tab title="Gravy">
        <SelectWithSearch
            :full_object="true"
            :optionsData="form.gravies"
            selected_by="id"
            :search_without_api="true"
            track_by="id"
            display="name"
            @selectedOption="selectedGravy($event)"
        ></SelectWithSearch>
        <b-table
          :items="final.gravies"          
          :fields="fields"
          :current-page="currentPage"
          :per-page="10"
        >
          <template v-slot:cell(item)="row">
            <p class="w-10">
            {{ row.item.name }}
            </p>
          </template>         
          <template v-slot:cell(comment)="row">
            <b-textarea type="number" v-model="row.item.comment"></b-textarea>
          </template>
          <template v-slot:cell(qty)="row">
            <div class="flex-col gap-1">
                <div class="flex-row">
                    <b-input type="number" v-model="row.item.qty_returned"></b-input> Pkts
                </div>
                <div class="flex-row" v-if="row.item.uom > 1 && row.item.units == 'pcs'">
                    <b-input type="number" v-model="row.item.qty_returned_pcs"></b-input> Pcs
                </div>
            </div>            
          </template>
          <template v-slot:cell(actions)="row">
            <b-button variant="danger" v-if="!returnOrder || (returnOrder && returnOrder.status == 'pending')" @click="deleteRow('gravy',row)"
              ><i class="fa fa-trash"></i
            ></b-button>
          </template>
        </b-table>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :key="final.gravies.length"
                  v-model="currentPage"
                  :total-rows="final.gravies.length"
                  :per-page="10"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Packaging">
        <SelectWithSearch
            :optionsData="form.packagings"
            selected_by="id"
            :search_without_api="true"
            :full_object="true"
            track_by="id"
            display="name"
            @selectedOption="selectedPackaging($event)"
        ></SelectWithSearch>
        <b-table
          :items="final.packagings"
          :fields="fields"
          :current-page="currentPage"
          :per-page="10"
        >
          <template v-slot:cell(item)="row">
            <p class="w-10">
            {{ row.item.name }}
            </p>
          </template>
          <template v-slot:cell(comment)="row">
            <b-textarea type="number" v-model="row.item.comment"></b-textarea>
          </template>
          <template v-slot:cell(qty)="row">
            <div class="flex-col gap-1">
                <div class="flex-row">
                    <b-input type="number" v-model="row.item.qty_returned"></b-input> Pkts
                </div>
                <div class="flex-row" v-if="row.item.units > 1">
                    <b-input type="number" v-model="row.item.qty_returned_pcs"></b-input> Pcs
                </div>
            </div>            
          </template>
          <template v-slot:cell(actions)="row">
            <b-button variant="danger" v-if="!returnOrder || (returnOrder && returnOrder.status == 'pending')" @click="deleteRow('packaging',row)"
              ><i class="fa fa-trash"></i
            ></b-button>
          </template>
        </b-table>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :key="final.packagings.length"
                  v-model="currentPage"
                  :total-rows="final.packagings.length"
                  :per-page="10"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <b-button v-if="!returnOrder || (returnOrder && returnOrder.status == 'pending')" class="mr-4" @click="submitOrder" variant="success">Submit</b-button>
    <b-button v-if="(returnOrder && (returnOrder.status == 'pending' || returnOrder.status == 'accepted'))" @click="markAsCompleted" variant="success">Mark Accept & Mark Completed</b-button>
  </div>
</template>

<script>
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import { GravyPath, PackagingPath } from "@/path";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    SelectWithSearch,
  },
  props: {
    selectedOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      currentPage: 1,
      fields: ["item","comment","qty_shipped","qty","actions"],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      issues: [
        {
            "key": "picking_error",
            "value": "Picking Error"
        },
        {
            "key": "rp_issue",
            "value": "Rp Issue"
        },
      ],
      form: {
        gravies: [],
        packagings: [],
      },
      return_data: {
        gravies: [],
        packagings: [],
      },
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      returnOrder : null,
      final: {
        selectedIssue: null,
        gravies: [],
        packagings: [],
      }
    };
  },
  mounted() {
    this.getOrderDetails();    
  },
  computed: {
    GravyPath() {
      return GravyPath;
    },
    PackagingPath() {
      return PackagingPath;
    },
  },
  methods: {
    deleteRow(type, row) {
        if (type == "gravy") {
            this.final.gravies.splice(row.index, 1);
        }else{
            this.final.packagings.splice(row.index, 1);
        }
    },
    selectedIssue(event) {
        this.final.selectedIssue = event;
    },
    async submitOrder() {
        try {
            let items = [];
            this.final.gravies.forEach(g => {
                items.push({
                    gravy_id: g.id,
                    qty_returned: g.qty_returned,
                    qty_returned_pcs: g.qty_returned_pcs,
                    comment: g.comment
                });
            });
            this.final.packagings.forEach(g => {
                items.push({
                    packaging_id: g.id,
                    qty_returned: g.qty_returned,
                    qty_returned_pcs: g.qty_returned_pcs,
                    comment: g.comment
                });
            });
            console.log(this.final);
           let res = await axios.post(this.baseUrl + GravyPath.ORDERS.SAVE_ORDER_RETURN, {
               order_id: this.selectedOrder.id,
               type_of_issue: this.final.selectedIssue.key,
               items,               
           });
           if(res.data.status){
               this.$emit("update");
               Swal.fire("success", "", "success");
           }
        } catch (error) {
            Swal.fire(error.message, "", "error");
        }  
    },
    selectedGravy(event) {
        if(this.final.gravies.find(f => f.id == event.id)){
            return;
        }
      this.final.gravies.push(event);
    },
    selectedPackaging(event) {
    if(this.final.packagings.find(f => f.id == event.id)){
        return;
    }
      this.final.packagings.push(event);
    },
    async getOrderReturnDetails() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ORDERS.GET_ORDER_RETURN, {
          params: {
            order_id: this.selectedOrder.id,
          },
        });
        if (res.data.status) {
            console.log(res.data.data,'res data');
            if(res.data.data){
                this.returnOrder = res.data.data;
                this.final.selectedIssue = this.issues.find(f => f.key == res.data.data.type_of_return);
                console.log(this.final, 'final');
                this.return_data.gravies = res.data.data.items.filter(f => f.gravy != null);
                this.return_data.packagings = res.data.data.items.filter(f => f.packaging != null);
                this.final.gravies = this.return_data.gravies.map(g => {
                    return {
                        id: g.gravy_id,
                        name: g.gravy.name,
                        qty_shipped: this.form.gravies.find(f => f.id == g.gravy_id).qty_shipped,
                        qty_returned: g.qty_returned,
                        qty_returned_pcs: g.qty_returned_pcs,
                        comment: g.comment,
                        uom: g.gravy.uom,
                        units: g.gravy.units
                    }
                });
                this.final.packagings = this.return_data.packagings.map(g => {
                    return {
                        id: g.packaging_id,
                        name: g.packaging.name,
                        qty_shipped: this.form.packagings.find(f => f.id == g.packaging_id).qty_shipped,
                        qty_returned: g.qty_returned,
                        qty_returned_pcs: g.qty_returned_pcs,
                        comment: g.comment,
                        uom: g.packaging.uom,
                        units: g.packaging.units
                    }
                });
            }
          
        }
      } catch (error) {
        console.log(error);
      }
    },
    async markAsCompleted() {
      try {
        let items = [];
        this.final.gravies.forEach(g => {
            items.push({
                gravy_id: g.id,
                qty_returned: g.qty_returned,
                qty_returned_pcs: g.qty_returned_pcs,
                comment: g.comment
            });
        });
        this.final.packagings.forEach(g => {
            items.push({
                packaging_id: g.id,
                qty_returned: g.qty_returned,
                qty_returned_pcs: g.qty_returned_pcs,
                comment: g.comment
            });
        });
        console.log(this.final);
        await axios.post(this.baseUrl + GravyPath.ORDERS.SAVE_ORDER_RETURN, {
            order_id: this.selectedOrder.id,
            type_of_issue: this.final.selectedIssue.key,
            items,               
        });
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to mark this return as completed?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, mark it!',
          cancelButtonText: 'No, cancel!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              let res = await axios.post(this.baseUrl + GravyPath.ORDERS.RETURN_MARK_ACCEPT_COMPLETED, {
                return_id: this.returnOrder.id,
              });
              if (res.data.status) {
                Swal.fire("success", "", "success");
                this.$emit("update");
              }
            } catch (error) {
              console.log(error);
            }
          }
        });        
      } catch (error) {
        console.log(error);
      }
    },
    async getOrderDetails() {
        console.log(this.selectedOrder);
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ORDERS.ORDER_ITEMS, {
          params: {
            order_id: this.selectedOrder.id,
          },
        });
        if (res.data.status) {
          console.log(res.data.data);
          this.form.gravies = res.data.data
            .filter((f) => f.gravy != null)
            .map((f) => {
              let g = f.gravy;
              g.qty_to_ship = f.qty_to_ship;
              g.qty_shipped = f.qty_shipped;
              g.batch_code = f.batch_code;
              if (f.no_qty_exists == 1) {
                g._rowVariant = "danger";
              }
              return g;
            });
          this.form.packagings = res.data.data
            .filter((f) => f.packaging != null)
            .map((f) => {
              let g = f.packaging;
              g.qty_to_ship = f.qty_to_ship;
              g.qty_shipped = f.qty_shipped;
              g.batch_code = f.batch_code;
              if (f.no_qty_exists == 1) {
                g._rowVariant = "danger";
              }
              return g;
            });
        }
        await this.getOrderReturnDetails();
        console.log(this.form);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

